export const getAppGreetingsPretext = () => {
  return 'app.settings.defaults.greetingsPretext';
};
